var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalQuestionCategory = function SvgHospitalQuestionCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hospital-question-category_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__b)",
    d: "M33.034 8.85H14.96a3.6 3.6 0 0 0-3.6 3.6v23.1a3.6 3.6 0 0 0 3.6 3.6h18.075a3.6 3.6 0 0 0 3.6-3.6v-23.1a3.6 3.6 0 0 0-3.6-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__c)",
    d: "M25.35 14.946v-2.23a.31.31 0 0 0-.307-.307h-2.082a.31.31 0 0 0-.307.308v2.229h-2.23a.31.31 0 0 0-.307.307v2.082c0 .17.138.308.308.308h2.229v2.229c0 .17.138.307.307.307h2.082c.17 0 .308-.138.308-.307v-2.23h2.229c.17 0 .307-.137.307-.307v-2.082a.31.31 0 0 0-.307-.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__d)",
    d: "M22.118 22.854h-3.485a.923.923 0 0 0-.922.922v3.485c0 .51.413.922.922.922h3.485c.51 0 .922-.413.922-.922v-3.485a.92.92 0 0 0-.922-.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__e)",
    d: "M29.36 22.854h-3.484a.92.92 0 0 0-.923.922v3.485c0 .51.413.922.923.922h3.484c.51 0 .923-.413.923-.922v-3.485a.92.92 0 0 0-.923-.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__f)",
    d: "M22.118 29.817h-3.485a.923.923 0 0 0-.922.922v3.485c0 .51.413.922.922.922h3.485c.51 0 .922-.413.922-.922v-3.485a.92.92 0 0 0-.922-.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hospital-question-category_svg__g)",
    d: "M29.36 29.817h-3.484a.92.92 0 0 0-.923.922v3.485c0 .51.413.922.923.922h3.484c.51 0 .923-.413.923-.922v-3.485a.92.92 0 0 0-.923-.922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__b",
    x1: 11.979,
    x2: 32.718,
    y1: 9.841,
    y2: 34.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72D5A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__c",
    x1: 21.476,
    x2: 26.528,
    y1: 13.767,
    y2: 18.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__d",
    x1: 17.981,
    x2: 22.769,
    y1: 23.124,
    y2: 27.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__e",
    x1: 25.225,
    x2: 30.013,
    y1: 23.124,
    y2: 27.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__f",
    x1: 17.981,
    x2: 22.769,
    y1: 30.087,
    y2: 34.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hospital-question-category_svg__g",
    x1: 25.225,
    x2: 30.013,
    y1: 30.087,
    y2: 34.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hospital-question-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgHospitalQuestionCategory;